<template>
	<div class="container-fluid">
		<!-- Begin page -->
		<div class="wrapper"> 
			<div class="content-page content-subProject">
				<div class="content">
					<div class="row">
						<div class="col-12">
							<div class="page-title-box">
								<div class="page-title-right"><Breadcrumb /></div>
								<h3 class="header-title mb-3">{{projectData.projectName}}专家评审列表</h3>
							</div>
							<!-- end page-title-box -->
						</div>
					</div>

					<el-table :data="exportReviewList" :header-cell-style="tableHeaderStyle" border style="width: 100%">
						<el-table-column prop="name" label="评审信息名称" header-align="center" align="left">
							<template slot-scope="scope">
								<el-button type="text" @click="goReview(scope.row)">{{scope.row.name}}</el-button>
								
							</template>
						</el-table-column>
						<el-table-column prop="reviewType" label="类别" width="50">
							<template slot-scope="scope">
								{{scope.row.reviewType == 0?'初评':scope.row.reviewType == 1?'复评':'终评'}}
							</template>
						</el-table-column>
						<el-table-column prop="createAdminName" label="创建人" width="100" align="center"></el-table-column>
						<el-table-column prop="reviewState" label="状态" width="100" align="center">
							<template slot-scope="scope">
								{{scope.row.reviewState|getReviewState}}
							</template>
						</el-table-column>
						<el-table-column prop="deClareNumber" label="待评课题数" width="100" align="center"></el-table-column>
						<el-table-column prop="groupNumber" label="评审组" width="80" align="center"></el-table-column>
						<el-table-column prop="peopleNumber" label="评审专家数" width="95" align="center"></el-table-column>
						<!-- <el-table-column prop="reviewStartTime" label="开始时间" width="100" align="center">
							<template slot-scope="scope">
								{{scope.row.reviewStartTime|getTime}}
							</template>
						</el-table-column> -->
						<el-table-column prop="reviewEndTime" label="预计结束时间" width="110" align="center">
							<template slot-scope="scope">
								{{scope.row.reviewEndTime|getTime}}
							</template>
						</el-table-column>
						<el-table-column label="操作" align="center">
							<template slot-scope="scope">
								<!-- <el-button size="mini" type="primary" v-if="scope.row.reviewState==1" @click="goReview(scope.row)">开始评审</el-button> -->
								<el-button style="margin-right: 10px;" size="mini" type="primary" @click="goReview(scope.row)">查看评审</el-button>
								<el-popconfirm title="这是一段内容确定删除吗？" @confirm="delReview(scope.row.id)" >
									<el-button slot="reference" size="mini" type="danger" v-if="scope.row.reviewState==1">删除</el-button>
								</el-popconfirm>
								<!-- <el-button size="mini" type="success"  v-if="[6].includes(+scope.row.reviewState)">结束评审</el-button> -->
							</template>
						</el-table-column>
					</el-table>
					<el-button style="margin-top: 20px;" type="primary" @click="addReviewDialogVisible=true">新建立项评审</el-button>
					 <el-pagination
					 style="text-align: center;margin-top: 20px;"
					      @size-change="handleSizeChange"
					      @current-change="handleCurrentChange"
					      :current-page="params.pageNumber"
					      :page-sizes="[10, 50, 100]"
					      :page-size="params.pageSize"
					      layout="total, sizes, prev, pager, next, jumper"
					      :total="total">
					    </el-pagination>
					
					<el-dialog title="提示" :visible.sync="addReviewDialogVisible" width="40%" :close-on-click-modal="false">
					  
						<el-form :model="addReviewForm" :rules="addReviewFormRules" ref="addReviewFormRef" label-width="120px" class="demo-ruleForm">
						  <el-form-item label="评审名称" prop="name">
						    <el-input v-model="addReviewForm.name"></el-input>
						  </el-form-item>
							<el-form-item label="评审方式" prop="reviewWay">
							  <el-radio-group v-model="addReviewForm.reviewWay">
							      <el-radio :label="0" :disabled="this.projectData.anonymousReviewState==0">匿名评审</el-radio>
							      <el-radio :label="1">非匿名评审</el-radio>
							    </el-radio-group>
							</el-form-item>
							<el-form-item label="评价类别" prop="reviewType">
							  <el-radio-group v-model="addReviewForm.reviewType">
							      <el-radio :label="0">初评</el-radio>
							      <el-radio :label="1">复评</el-radio>
							      <el-radio :label="2">终评</el-radio>
							    </el-radio-group>
							</el-form-item>
							<el-form-item label="评语" prop="evaluationWay">
								<el-radio-group v-model="addReviewForm.evaluationWay">
								    <el-radio :label="0">不必填</el-radio>
								    <el-radio :label="1">必填</el-radio>
								  </el-radio-group>
							</el-form-item>
							<!-- <el-form-item label="评审开始日期" prop="reviewStartTime">
							  <el-date-picker
							  	v-model="addReviewForm.reviewStartTime"
							  	:picker-options="pickerOptions"
							  	type="date"
							  	value-format="yyyy-MM-dd HH:mm:ss"
							  	format="yyyy-MM-dd"
							  	placeholder="选择日期"
							  ></el-date-picker>
							</el-form-item> -->
							<el-form-item label="评审截止日期" prop="reviewEndTime">
							  <el-date-picker
							  	v-model="addReviewForm.reviewEndTime"
							  	:picker-options="pickerOptions"
							  	type="date"
							  	value-format="yyyy-MM-dd HH:mm:ss"
							  	format="yyyy-MM-dd"
							  	placeholder="选择日期"
							  ></el-date-picker>
							</el-form-item>
						</el-form>
						
					  <span slot="footer" class="dialog-footer">
					    <el-button type="danger" @click="addReviewDialogVisible = false">关闭窗口</el-button>
					    <el-button type="primary" @click="save">保存</el-button>
					  </span>
					</el-dialog>
					
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Breadcrumb from '@/views/backstage/components/Breadcrumb.vue';
import { getExpertReviewList,addReviewBaseInfo,delReviewById } from '@/api/after/expertReviewSettings.js';
export default {
	components: {
		Breadcrumb
	},
	filters:{
		getTime(val){
			if (val) {
				return val.slice(0,10)
			}
		},
		// 获取正确的评审状态
		getReviewState(val){
			if (val == 1) {
				return '课题分组准备阶段'
			}else if (val == 2) {
				return '分配专家阶段'
			}else if (val == 3) {
				return '设置评分标准阶段'
			}else if (val == 4) {
				return '开启评审打分阶段'
			}else if ([5,6].includes(val)) {
				return '专家评审中'
			}else if (val == 7) {
				return '结束'
			}
		}
	},
	data() {
		return {
			 tableHeaderStyle: { backgroundColor: "#7e9be2", color: "#fff" },
			projectData:{},//项目数据
			exportReviewList: [],
			params: {
				pageNumber: 1,
				pageSize: 10,
				projectId:0
			},
			total:0,
			addReviewDialogVisible:false,
			addReviewForm:{
				name:'',//	评审名称
				reviewWay:'',//评审方式(0:匿名评审,1:非匿名评审)
				reviewType:'',//评审类型(0:初评,1:复评,2::终评)
				evaluationWay:'',//评语方式(0:不必填,1:必填)
				reviewEndTime:'',//评审截止日期
				reviewStartTime:'',//评审开始日期
			},
			addReviewFormRules:{
				name:[{ required: true, message: '请输入评审名称', trigger: 'blur' }],
				reviewWay:[{ required: true, message: '请选择评审方式', trigger: 'change' }],
				reviewType:[{ required: true, message: '请选择评审类型', trigger: 'change' }],
				evaluationWay:[{ required: true, message: '请选择评语', trigger: 'change' }],
				reviewEndTime:[{ required: true, message: '请选择评审截止日期', trigger: 'change' }],
				reviewStartTime:[{ required: true, message: '请选择评审开始日期', trigger: 'change' }],
			},
			pickerOptions:{
				disabledDate(time) {
					return time.getTime() < Date.now() - 86400000
				},
			}
		};
	},
	created() {
		let projectData=sessionStorage.getItem('projectData')
		if(projectData){
			this.projectData=JSON.parse(projectData)
			this.params.projectId = this.projectData.id;
			this.getExpertReviewList()
		}else{
			this.$message({
				type:'error',
				message:'参数错误',
				duration:1500,
				onClose:()=>{
					this.$router.go(-1)
				}
			})
		}
	},
	methods: {
		// 跳转到专家评审设置页面
		goReview(data){
			this.$router.push({path:'/backstage/expertReviewSettings',query:{projectId:this.projectData.id,reviewId:data.id}})
		},
		// 删除评审
		delReview(id){
			this.delReviewById(id)
		},
		// 删除评审
		async delReviewById(id){
			const res = await delReviewById(id)
			if (res.code == 200) {
				this.$message.success('删除评审成功！')
				this.getExpertReviewList()
			}
		},
		// 保存评审基本信息
		save(){
			this.$refs.addReviewFormRef.validate(async (valid) => {
				if (valid) {
					this.addReviewForm.projectId = +this.projectData.id
					this.addReviewForm.reviewStartTime=this.getNowFormatDate()
					const res = await addReviewBaseInfo(this.addReviewForm)
					if (res.code == 200 ) {
						this.$router.push(`/backstage/expertReviewSettings?projectId=${this.projectData.id}&projectName=${this.projectData.projectName}&reviewId=${res.data}&reviewType=${this.addReviewForm.reviewType}`)
					}
				}
			})
		},
		getNowFormatDate() {
			var date = new Date();
			var seperator1 = "-";
			var year = date.getFullYear();
			var month = date.getMonth() + 1;
			var strDate = date.getDate();
			if (month >= 1 && month <= 9) {
				month = "0" + month;
			}
			if (strDate >= 0 && strDate <= 9) {
				strDate = "0" + strDate;
			}
			var currentdate = year + seperator1 + month + seperator1 + strDate;
			currentdate =currentdate+' 00:00:00';
			return currentdate;
		},
		// 获取专家评审列表
		async getExpertReviewList() {
			const res = await getExpertReviewList(this.params);
			if (res.code == 200) {
				console.log('评审类表',res);
				this.exportReviewList = res.data.records
				this.total = res.data.total
			}else{
				this.$message.error(res.data)
			}
		},
		handleSizeChange(val){
			this.params.pageSize=val
		},
		handleCurrentChange(val){
			this.params.pageNumber = val
		},
	}
};
</script>

<style scoped>
</style>
